import { defineStore } from 'pinia';
import type { IState } from './interface';
import { useStoreCommon } from '@qm-activity/common/store/common';
import { apiShareActionReport } from '@common/http/api';
export const useStore = defineStore('store', {
    state: (): IState => {
        return {
            popManage: {
                inviteCode: false, // 邀请口令
                share: false, //分享
            },
            mainData: {
                pool_amount: 10000,
            },
        };
    },
    actions: {
        setPopManage(key: string, value: boolean) {
            if (key === 'share') {
                apiShareActionReport(this.mainData.invite_code);
            }
            this.popManage[key] = value;
        },
        setMainData(data: Record<string, any>) {
            this.mainData = {
                ...this.mainData,
                ...data,
            };
        },
    },
});
